import axios from 'axios';
import apiConfig from '../api.config';

export default function createPaymentMethodRequest({ userId, chainId }) {
  const {
    host,
    URIs: { createPaymentMethod },
  } = apiConfig;

  const uri = `${host}${createPaymentMethod}`;

  return axios
    .post(uri, JSON.stringify({ userId, chainId }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
